export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=725844c3"


//////////////////
// WEBPACK FOOTER
// ./src/components/system/index.vue?vue&type=template&id=725844c3
// module id = X05g
// module chunks = 0